import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { Product, ProductGroup, groupImages } from '../services/dto/orwi-product';

export interface MenuState {
    selectedGroup: ProductGroup
    selectedSubGroup: ProductGroup
    products: Product[]
    selectedProduct : Product
    infiniteProducts: Product[],
    groups: ProductGroup[]
    allGroups: ProductGroup[]
    subGroups: ProductGroup[],
    giftSelected : boolean,
    searchedProducts: Product[],
    searchKeyword : string,
    intersectingGroup: ProductGroup,
    productGroupImages: groupImages[]
    
}

export function createInitialState(): MenuState {
    return {
     selectedGroup : null,
     selectedSubGroup: null,
     infiniteProducts: [],
     selectedProduct : null,     
     products: [],
     groups: [],
     allGroups: [],
     subGroups: [],
     giftSelected : false,
     searchedProducts: [],
     searchKeyword: "",
     intersectingGroup: null,
     productGroupImages: []
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'orwi-menu' })
export class MenuStore extends Store<MenuState> {

  constructor() {
    super(createInitialState());
  }

}